import { Container } from '@codeparva/ui-components-library';
import React, { useState, useEffect } from 'react';
import { getImageType } from '../../../../utilities/gatsbyImageHelper';
import { weakKey } from '../../../../utilities/weakKey';
import HorizontalCards from './components/helpers/HorizontalCards';
import { VerticalCardsComponent } from './components/helpers/VerticalCards';
import { ThemeContext } from './components/hooks/themeContext';
import { UnitAvailabilityContext } from './components/hooks/unitAvailabilityContext';
import { UnitAvailabilityTypes } from './UnitAvailabilityTypes';
import {
  filterUnitResponseData,
  viewRatesFilterBuilder,
} from './components/helpers/viewRatesFilterHelper';
import { ViewRatesFilter } from './components/ViewRatesFilter';
import { Text } from '../../../../components/textVariations';
import { AlertModal } from './components/helpers/AlertModal';

export const UnitAvailability = ({
  res,
  showVacantUnit = true,
  UnitAvailabilityConfig,
  onSetIndividualData,
  WhatWeOfferConfig,
  locationStrapiId,
  facilityName,
  facilityIdDetails,
  logOutHandler,
  globalContext,
  selectedLocation,
}: UnitAvailabilityTypes.IUnitAvailabilty) => {
  const [activeFilters, setActiveFilters] = useState<
    UnitAvailabilityTypes.TFilterObject[]
  >([]);
  const [unitAvailabilityData, setUnitAvailabilityData] = useState<
    UnitAvailabilityTypes.TData[]
  >(res.unitTypeData);
  const { variant, theme } = UnitAvailabilityConfig;
  const selectTitleClassName = () => {
    return `unitAvailabilitySectionTitle has-text-left has-text-text-color-primary border-left-2 border-primary`;
  };
  const filter = viewRatesFilterBuilder(res.unitTypeData);

  useEffect(() => {
    const filteredResponse = filterUnitResponseData(
      res.unitTypeData,
      activeFilters
    );
    setUnitAvailabilityData([...filteredResponse]);
  }, [activeFilters]);

  const renderNoUnitsAvailable = () => {
    if (filter?.length) {
      return (
        <div className="noUnitsAvailable">
          <Text renderAs="p">No units Of selected filter are available</Text>
        </div>
      );
    }
    return null;
  };

  const HorizontalTiles = () => {
    if (res) {
      let defaultUnitImage: any;
      if (UnitAvailabilityConfig.defaultGatsbyImage) {
        defaultUnitImage =
          UnitAvailabilityConfig.defaultGatsbyImage[0]?.defaultImage;
        UnitAvailabilityConfig.defaultUnitImage = defaultUnitImage;
      }
      const unitTypeRes = unitAvailabilityData;
      const { isPaymentEnabled } = res || {};
      if (unitTypeRes.length > 0) {
        return (
          <div className="horizontalCardContainer is-flex is-flex-direction-row is-justify-content-center is-flex-wrap-wrap">
            {unitTypeRes.map(
              (data: UnitAvailabilityTypes.TData, index: number) => {
                const media = data.customArt;
                const defaultMedia = defaultUnitImage ?? {};
                const img = getImageType(data, media, defaultMedia);
                if (
                  !showVacantUnit &&
                  data.vacantUnitsCount.total_count === 0
                ) {
                  return <></>;
                }
                return (
                  data && (
                    <HorizontalCards
                      data={{ ...data, isPaymentEnabled }}
                      UnitAvailabilityConfig={UnitAvailabilityConfig}
                      key={weakKey({ data })}
                      onSetIndividualData={onSetIndividualData}
                      WhatWeOfferConfig={WhatWeOfferConfig}
                      index={index}
                      transformedGatsbyImageData={img}
                      facilityIdDetails={facilityIdDetails}
                    />
                  )
                );
              }
            )}
          </div>
        );
      }
      return renderNoUnitsAvailable();
    }
    return null;
  };

  const VerticalCards = () => {
    if (res) {
      const defaultUnitImage = res.defaultUnitImage;
      UnitAvailabilityConfig.defaultUnitImage = defaultUnitImage;
      const unitTypeRes = unitAvailabilityData;
      const { isPaymentEnabled } = res || {};
      if (unitTypeRes.length > 0) {
        return (
          <div>
            <div
              className={`is-flex is-flex-direction-row is-justify-content-space-between is-flex-wrap-wrap unitAvailabilityDiv`}
            >
              {unitTypeRes.map(
                (data: UnitAvailabilityTypes.TData, index: number) => {
                  const media =
                    data.customArt?.custom_art_single_image?.data.attributes;
                  const defaultMedia =
                    UnitAvailabilityConfig.defaultUnitImage[0].default_image
                      .data.attributes;
                  const img = getImageType(data, media, defaultMedia);
                  if (
                    !showVacantUnit &&
                    data.vacantUnitsCount.total_count === 0
                  ) {
                    return <></>;
                  }
                  return (
                    <VerticalCardsComponent
                      data={{ ...data, isPaymentEnabled }}
                      UnitAvailabilityConfig={UnitAvailabilityConfig}
                      key={weakKey(data)}
                      theme="dark"
                      onSetIndividualData={onSetIndividualData}
                      WhatWeOfferConfig={WhatWeOfferConfig}
                      index={index}
                      transformedGatsbyImageData={img}
                      facilityIdDetails={facilityIdDetails}
                    />
                  );
                }
              )}
            </div>
          </div>
        );
      }
      return renderNoUnitsAvailable();
    }
    return null;
  };

  const renderVariant = (variantType: UnitAvailabilityTypes.TVariantType) => {
    switch (variantType) {
      case 'vertical':
        return <VerticalCards />;
      default:
        return <HorizontalTiles />;
    }
  };

  if (!res.unitTypeData?.length) {
    return null;
  }

  return (
    <ThemeContext.Provider value={theme}>
      <UnitAvailabilityContext.Provider
        value={{
          bevStatus: res.bevStatus,
          locationStrapiId: locationStrapiId,
          facilityName,
          globalContext,
        }}
      >
        <>
          <Container className="UnitAvailabiltyContainer cp-section-bg-unit-light">
            {UnitAvailabilityConfig.title.show && (
              <div className="is-flex unitCardsTitle">
                <span className="UnitAvailabiltyContainerHeading"></span>
                <h3
                  className={
                    UnitAvailabilityConfig.title.showOnMobile
                      ? selectTitleClassName()
                      : `${selectTitleClassName()} is-hidden-mobile`
                  }
                >
                  {UnitAvailabilityConfig.title.name}
                </h3>
              </div>
            )}
            {WhatWeOfferConfig && filter?.length > 0 && (
              <ViewRatesFilter
                unitsFilter={filter}
                activeFilters={activeFilters}
                activeFilterStateHandler={setActiveFilters}
              />
            )}
            {renderVariant(variant)}
          </Container>
          <AlertModal
            alertModalInfo={globalContext?.alertModalInfo}
            setAlertModalInfo={globalContext?.setAlertModalInfo}
            logOutHandler={logOutHandler}
            locationStrapiId={locationStrapiId}
            facilityName={facilityName}
            facilityIdDetails={facilityIdDetails}
            selectedLocation={selectedLocation}
            unitsData={res}
          />
        </>
      </UnitAvailabilityContext.Provider>
    </ThemeContext.Provider>
  );
};
